import { faChevronRight } from '@fortawesome/pro-solid-svg-icons';
import styled from 'styled-components';

import { Link } from '@sorare/routing';

import { FontAwesomeIcon } from '@sorare/core/src/atoms/icons';
import { Horizontal, Vertical } from '@sorare/core/src/atoms/layout/flex';
import { DrukWide24 } from '@sorare/core/src/components/marketing/typography';
import { HELP } from '@sorare/core/src/constants/routes';
import { tabletAndAbove } from '@sorare/core/src/style/mediaQuery';

import { Search } from 'components/Search';
import { SubmitRequest } from 'components/SubmitRequest';
import { Category, Section } from 'hooks/zendesk';
import { categoryPath, sectionPath } from 'lib/path';

const BreadcrumbWrapper = styled(Horizontal).attrs({ gap: 2 })`
  flex-wrap: wrap;
`;

const Wrapper = styled(Horizontal)`
  justify-content: space-between;

  & > button {
    display: none;

    @media (${tabletAndAbove}) {
      display: flex;
    }
  }
`;

interface Props {
  category?: Category;
  section?: Section;
}

export const Breadcrumb = ({ category, section }: Props) => {
  return (
    <Vertical gap={4}>
      <Wrapper>
        <BreadcrumbWrapper>
          <DrukWide24 as="h2">
            <Link to={HELP}>Sorare</Link>
          </DrukWide24>
          {category && (
            <>
              <FontAwesomeIcon icon={faChevronRight} />
              <DrukWide24 as="h2">
                <Link to={categoryPath(category)}>{category.name}</Link>
              </DrukWide24>
            </>
          )}
          {section && (
            <>
              <FontAwesomeIcon icon={faChevronRight} />
              <DrukWide24 as="h2">
                <Link to={sectionPath(section)}>{section.name}</Link>
              </DrukWide24>
            </>
          )}
        </BreadcrumbWrapper>
        <SubmitRequest />
      </Wrapper>
      <Search />
    </Vertical>
  );
};
